import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export function createTranslateLoader(http: HttpClient): TranslateLoader {
  return new CustomTranslateHttpLoader(http, './assets/lang/', '.json');
}

export class CustomTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private prefix: string = './assets/lang/',
    private suffix: string = '.json'
  ) {}

  public getTranslation(lang: string): Observable<any> {
    return this.http.get(`${this.prefix}${lang}${this.suffix}`, {
      responseType: 'json', // Explicitly set JSON responseType
      headers: new HttpHeaders({ 'Accept': 'application/json' }) // Optional: Ensure correct headers
    });
  }
}
